<template>
  <div class="reservations">
    <Loading v-if="loading" />
    <div class="reservations__header">
      <div class="reservations__header-pickupBox">
        <Dropdown
          class="reservations__header-pickupBox-dropdown"
          :selectedOption="selectedReservations.selectedOption"
          :options="selectedReservations.options"
          :multiple="true"
          @selectOption="selectReservations"
          data-testid="dropdownReservationPickupBox"
        />
      </div>
      <div class="reservations__header-search">
        <Button
          v-if="false"
          class="reservations__header-search-button"
          variant="filled"
          :title="$t('newBookingPharmacyPickup')"
          @click="reserve"
        />
        <div class="input-block">
          <img
            class="dropdown-img"
            src="@/assets/icons/Search.svg"
            alt="Search"
          />
          <input
            v-model="search"
            class="input-search"
            :placeholder="$t('search')"
            @input="changeInput"
          />
          <Dropdown
            className="dropdown-search"
            :selectedOption="getSearchBy.selectedOption"
            :options="getSearchBy.options"
            @selectOption="changeSearchBy"
            data-testid="dropdownReservationSearch"
          />
        </div>
      </div>
    </div>
    <div v-if="data.length">
      <Table
        :data="data"
        :columns="columns"
        :idActiveDelivery="idActiveDelivery"
        selectedField="deliveryId"
        @addDescription="addDescription"
        @resendSMSRequest="resendSMSRequest"
        @deleteReservationTable="deleteReservationTable"
        @pickedUpReservation="pickedUpReservation"
        @openQRCode="openQRCode"
        @editShelf="editShelf"
        @goToItem="infoReservation"
      />
    </div>
    <div v-if="!data.length" class="reservations__notReservations">
      <p>{{ $t('noReservations') }}</p>
    </div>
  </div>
  <AssignDelivery
    :showModalAssign="showModalAssign"
    :activeReservations="activeReservations"
    @loadPickupBoxes="loadPickupBoxes"
    @closeModal="showModalAssign = false"
    @assignDeliveryRequest="assignDeliveryRequest"
  />
  <ReserveLocker
    v-if="showModal"
    :showModal="showModal"
    :loadPickupBoxes="loadPickupBoxes"
    @closeModal="showModal = false"
  />
  <ResendSMS
    :showModalResendSMS="showModalResendSMS"
    :deliveryId="idDelivery"
    @closeModal="showModalResendSMS = false"
    @loadPickupBoxes="loadPickupBoxes"
  />
  <DeleteReservation
    :showModalDelete="showModalDelete"
    :idPickupBox="idPickupBox"
    :idDelivery="idDelivery"
    @closeModal="showModalDelete = false"
    @deleteReservationRequest="deleteReservationRequest"
    @destroyReservationRequest="destroyReservationRequest"
  />
  <AddDescription
    :showModalAddDescription="showModalAddDescription"
    :idPickupBox="idPickupBox"
    :activeReservations="activeReservations"
    :showDecodedSsn="showDecodedSsn"
    @getDecodedSsn="getDecodedSsn"
    @closeModal="showModalAddDescription = false"
  />
  <PickedUpReservation
    :showModalPickedUpReservation="showModalPickedUpReservation"
    :idDelivery="idDelivery"
    :activeReservations="activeReservations"
    @closeModal="closeModalPickedUpReservation"
    @loadPickupBoxes="loadPickupBoxes"
  />
  <OpenQRCode
    :showQRCode="showQRCode"
    :idActiveDelivery="idActiveDelivery"
    @closeModal="showQRCode = false"
  />
  <InfoReservation
    :showModalInfoReservation="showModalInfoReservation"
    :activeReservations="activeReservations"
    :showDecodedSsn="showDecodedSsn"
    @getDecodedSsn="getDecodedSsn"
    @closeModal="showModalInfoReservation = false"
  />
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';

import AssignDelivery from '@/duplicatePages/AssignDelivery/AssignDelivery.vue';
import ReserveLocker from './ReserveLocker/ReserveLocker.vue';
import ResendSMS from '@/duplicatePages/ResendSMS/ResendSMS.vue';
import AddDescription from './AddDescription/AddDescription.vue';
import DeleteReservation from './DeleteReservation/DeleteReservation.vue';
import OpenQRCode from '@/duplicatePages/OpenQRCode/OpenQRCode.vue';
import PickedUpReservation from '@/duplicatePages/PickedUpReservation/PickedUpReservation.vue';
import InfoReservation from '@/duplicatePages/InfoReservation/InfoReservation.vue';

import { InputFileEvent, Option } from '@/types';
import {
  DataReservations,
  PickupBox,
  Reservation,
  SSNData
} from '@/store/modules/pharmacy/types';

import { searchActions, columns } from './configs';

@Options({
  name: 'Reservations',
  emits: [
    'deleteReservationRequest',
    'assignDeliveryRequest',
    'loadPickupBoxes',
    'getDecodedSsn',
    'destroyReservationRequest'
  ],
  components: {
    Loading,
    AssignDelivery,
    ReserveLocker,
    ResendSMS,
    AddDescription,
    DeleteReservation,
    PickedUpReservation,
    OpenQRCode,
    InfoReservation
  },
  data() {
    return {
      selectedReservations: {
        selectedOption: [],
        options: {}
      },
      getSearchBy: {
        selectedOption: {
          value: 'deliveryId',
          label: this.$t('kolliID')
        },
        options: searchActions(this.$t)
      },
      data: [],
      dataSearchBy: [],
      dataReservations: [],
      dataPharmacyReservations: [],
      activeReservations: null,
      columns: columns(this.$t),
      activePickupBox: null,
      activePickupBoxes: null,
      idPickupBox: '',
      idDelivery: '',
      pharmacyId: '',
      search: '',
      idActiveDelivery: '',
      showDecodedSsn: '',
      loading: false,
      showQRCode: false,
      showModal: false,
      showModalAssign: false,
      showModalDelete: false,
      showModalResendSMS: false,
      showModalAddDescription: false,
      showModalInfoReservation: false,
      showModalPickedUpReservation: false
    };
  },
  created() {
    this.loadPickupBoxes();
  },
  computed: {
    ...mapState('pharmacy', [
      'pharmacy',
      'pickupBoxes',
      'decodedSsn',
      'deliveryFindBySSN'
    ])
  },
  updated() {
    if (this.pickupBoxes && this.pharmacy) {
      this.selectedReservations.selectedOption =
        this.pickupBoxAndPharmacyOptions;
    }
  },
  methods: {
    ...mapActions('pharmacy', [
      'getPickupBoxesByPharmacy',
      'deleteReservation',
      'deletePharmacyReservation',
      'getPharmacy',
      'updatePharmacyReservation',
      'getDeliveryShowDecodedSsn',
      'destroyReservation',
      'assignDelivery',
      'getDeliveryFindBySSN'
    ]),
    /* eslint-disable */
    async loadPickupBoxes() {
      this.loading = true;

      const { id } = this.$route.params;
      await this.getPickupBoxesByPharmacy(id);
      await this.getPharmacy(id);

      this.getReservations(this.pickupBoxes);
      this.initPickupBoxOptions();

      this.loading = false;
    },
    initPickupBoxOptions() {
      this.pickupBoxOptions = this.pickupBoxes.map((i: PickupBox) => ({
        value: i.info.id,
        label: i.info.name,
        img: require('@/assets/icons/PickupBox.svg')
      }));

      const pharmacyReservations = {
        value: 'pharmacyReservations',
        label: this.$t('pharmacyReservations')
      };

      this.selectedReservations.options = {
        pharmacyReservations,
        ...this.pickupBoxOptions
      };

      this.pickupBoxAndPharmacyOptions = [
        ...this.pickupBoxOptions,
        pharmacyReservations
      ];
    },
    selectReservations(option: Option) {
      this.selectedReservations.selectedOption = option;

      const selectedReservations = this.selectedReservations.selectedOption.map(
        (i: Option) => i.value
      );

      this.activePickupBoxes = this.pickupBoxes.filter((pickupBox: PickupBox) =>
        selectedReservations.includes(pickupBox.info.id)
      );

      this.getReservations(this.activePickupBoxes);
      this.getSSN();
    },
    getReservations(activePickupBoxes: readonly PickupBox[]) {
      this.dataReservations = activePickupBoxes.reduce(
        (reservations: DataReservations[] | any, pickupBox: PickupBox) =>
          pickupBox.reservations
            ? [...reservations, ...pickupBox.reservations]
            : reservations,
        []
      );
    },
    getSSN() {
      if (this.getSearchBy.selectedOption.value === 'ssn') {
        if (this.search === '') {
        } else {
          const mapOption = this.pickupBoxAndPharmacyOptions.map(
            (i: Option) => i.value
          );

          const optionPharmacy: Record<string, unknown> = {
            pharmacyReservations: this.pharmacy.id
          };

          const deliveryFindBySSNData = mapOption.flatMap((i: any) => {
            const key = optionPharmacy[i] || i;
            return this.deliveryFindBySSN[key] || [];
          });

          this.data = deliveryFindBySSNData;
          this.dataSearchBy = deliveryFindBySSNData;
        }
      }
    },
    reserve() {
      this.showModal = true;
    },
    changeInput(e: InputFileEvent) {
      const { value } = e.target;

      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        if (value === '') {
          this.loadPickupBoxes();
        } else if (this.getSearchBy.selectedOption.value === 'phoneNumber') {
          this.data = [...this.dataSearchBy].filter((item: DataReservations) =>
            item.phoneNumber.toLowerCase().includes(value?.toLowerCase())
          );
        } else if (this.getSearchBy.selectedOption.value === 'deliveryId') {
          this.data = [...this.dataSearchBy].filter((item: DataReservations) =>
            item.deliveryId.toLowerCase().includes(value?.toLowerCase())
          );
        } else if (this.getSearchBy.selectedOption.value === 'ssn') {
          this.changeSearchBy(this.getSearchBy.selectedOption);
        }
      }, 600);
    },
    async changeSearchBy(option: Option) {
      this.getSearchBy.selectedOption = option;

      if (
        this.getSearchBy.selectedOption?.value === 'ssn' &&
        this.search !== ''
      ) {
        this.loading = true;

        await this.getDeliveryFindBySSN({
          ssn: this.search,
          unassigned: false
        });
        this.getSSN();

        this.loading = false;
      } else {
        this.data = [...this.dataSearchBy].filter(
          (item: DataReservations[] | any) =>
            item[this.getSearchBy.selectedOption.value]
              ?.toLowerCase()
              .includes(this.search.toLowerCase())
        );
      }
    },
    addDescription(deliveryId: string) {
      this.idDelivery = deliveryId;

      this.activeReservations = this.data.find(
        (i: DataReservations) => i.deliveryId === deliveryId
      );

      this.activePickupBox = this.pickupBoxes.find((pickupBox: PickupBox) =>
        pickupBox.reservations
          .map((i: Reservation) => i.deliveryId)
          .includes(this.activeReservations.deliveryId)
      );

      this.idPickupBox = this.activePickupBox?.id;

      this.showModalAddDescription = true;
    },
    async assignDeliveryRequest(
      deliveryId: string,
      description: string,
      shelf: string
    ) {
      this.loading = true;

      const { id } = this.$route.params;

      const payload = {
        deliveryStatus: 'update',
        shelf: [...shelf]
      };

      await this.updatePharmacyReservation({
        data: payload,
        pharmacyId: id,
        deliveryId: deliveryId
      });

      this.loading = false;

      this.loadPickupBoxes();
      this.showModalAssign = false;
      this.showModalPickedUpReservation = false;
    },
    resendSMSRequest(deliveryId: string) {
      this.idDelivery = deliveryId;
      this.showModalResendSMS = true;
    },
    deleteReservationTable(deliveryId: string) {
      this.idDelivery = deliveryId;

      this.activeReservations = this.data.find(
        (i: DataReservations) => i.deliveryId === deliveryId
      );

      this.activePickupBox = this.pickupBoxes.find((pickupBox: PickupBox) =>
        pickupBox.reservations
          .map((i: Reservation) => i.deliveryId)
          .includes(this.activeReservations.deliveryId)
      );

      this.idPickupBox = this.activePickupBox?.id;

      this.showModalDelete = true;
    },
    async deleteReservationRequest(boxId: string, deliveryId: string) {
      if (!this.activeReservations.lockerId) {
        this.loading = true;
        const { id } = this.$route.params;

        const payload = {
          reservedTime: this.activeReservations.reservedTime
        };

        await this.deletePharmacyReservation({
          data: payload,
          pharmacyId: id,
          deliveryId: deliveryId
        });
      } else {
        this.loading = true;

        await this.deleteReservation({
          boxId: boxId,
          deliveryId: deliveryId
        });
      }
      this.loading = false;
      this.showModalDelete = false;

      const { id } = this.$route.params;
      this.loadPickupBoxes();
    },
    pickedUpReservation(deliveryId: string) {
      this.idDelivery = deliveryId;

      this.activeReservations = this.data.find(
        (i: DataReservations) => i.deliveryId === deliveryId
      );

      this.showModalPickedUpReservation = true;
    },
    infoReservation(deliveryId: string) {
      this.activeReservations = this.data.find(
        (i: DataReservations) => i.deliveryId === deliveryId
      );

      this.showModalInfoReservation = true;
    },
    openQRCode(id: string) {
      this.activeDelivery = [
        ...(Object.values(this.data) as DataReservations[])
      ].find((i: DataReservations) => i.deliveryId === id);

      this.idActiveDelivery = this.activeDelivery.deliveryId;

      this.showQRCode = true;
    },
    editShelf(id: string) {
      this.activeReservations = [
        ...(Object.values(this.data) as DataReservations[])
      ].find((i: DataReservations) => i.deliveryId === id);

      this.showModalAssign = true;
    },
    async getDecodedSsn(deliveryId: string) {
      this.idDelivery = deliveryId;

      this.activeReservations = this.data.find(
        (i: DataReservations) => i.deliveryId === deliveryId
      );

      this.activePickupBox = this.pickupBoxes.find((pickupBox: PickupBox) =>
        pickupBox.reservations
          .map((i: Reservation) => i.deliveryId)
          .includes(this.activeReservations.deliveryId)
      );

      this.loading = true;

      this.idPickupBox = this.activePickupBox?.id;
      const { id } = this.$route.params;

      const params: SSNData = {
        deliveryId: this.activeReservations.deliveryId,
        reservedTime: this.activeReservations.reservedTime
      };

      if (this.idPickupBox) {
        params.pickupboxId = this.idPickupBox;
      } else {
        params.pharmacyId = id;
      }

      await this.getDeliveryShowDecodedSsn(params);

      this.showDecodedSsn = this.decodedSsn.ssn;
      this.loading = false;
    },
    async destroyReservationRequest(deliveryId: string) {
      const { id } = this.$route.params;

      const payload = {
        pharmacyId: id,
        deliveryId
      };

      await this.destroyReservation(payload);

      this.loading = false;
      this.showModalDelete = false;

      this.loadPickupBoxes();
    },
    closeModalPickedUpReservation() {
      this.showModalPickedUpReservation = false;
    }
  },
  watch: {
    'selectedReservations.selectedOption': {
      immediate: true,
      handler(option: (Option | string)[]) {
        this.pickupBoxAndPharmacyOptions = option;
        const mapOption = this.pickupBoxAndPharmacyOptions.map(
          (i: Option) => i.value
        );

        if (
          !mapOption.includes('pharmacyReservations') ||
          mapOption.includes('pharmacyReservations')
        ) {
          this.dataReservations = this.dataReservations.filter(
            (i: DataReservations) => i.lockerId.length
          );
        }

        if (this.pharmacy) {
          if (mapOption.includes('pharmacyReservations')) {
            this.dataPharmacyReservations = (
              this.pharmacy.reservations || []
            ).filter(
              (reservation: DataReservations) => reservation.unassigned !== true
            );
          } else {
            this.dataPharmacyReservations = [];
          }
        }

        this.data = [
          ...this.dataReservations,
          ...this.dataPharmacyReservations
        ];

        this.dataSearchBy = this.data;

        this.getSSN();
      }
    },
    showModal() {
      this.showDecodedSsn = '';
    },
    showModalAddDescription() {
      this.showDecodedSsn = '';
    },
    showModalInfoReservation() {
      this.showDecodedSsn = '';
    }
  }
})
export default class Reservations extends Vue {}
</script>

<style lang="scss">
.reservations {
  padding: 24px;
  .reservations__header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 23px;
    column-gap: 10px;
    .reservations__header-pickupBox {
      .reservations__header-pickupBox-dropdown {
        height: 40px;
        width: 288px !important;
      }
    }
    .reservations__header-search {
      display: flex;
      .reservations__header-search-button {
        width: 190px;
      }
      .input-block {
        display: flex;
        position: relative;
        margin-left: 10px;
        .input-search {
          width: 245px;
          height: 38px;
          padding-left: 36px;
          font-size: $fourteenSize;
          border: 1px solid $border;
          border-right: 0;
          border-top-left-radius: 8px;
          border-bottom-left-radius: 8px;
          outline: none;
        }
        .dropdown-img {
          position: absolute;
          top: 14px;
          left: 17px;
        }
        .dropdown {
          max-width: 175px;
          .dropdown-search {
            height: 40px;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
      }
    }
  }
  .reservations__notReservations {
    margin-top: 24px;
  }
}
</style>
